import { useState } from "react";
import "./CovidProto.css";
import PasoDos from "./PasoDos/PasoDos";
import PasoTres from "./PasoTres/PasoTres";
import PasoUno from "./PasoUno/PasoUno";

const CovidProto = ({setViewCovid}) => {
   const [paso,setPaso] = useState(1);

    return (
        paso === 1 ? <PasoUno setPaso={setPaso}/>:
        paso === 2 ? <PasoDos setPaso={setPaso} setViewCovid={setViewCovid}/>: 
        paso === 3 ? <PasoTres setPaso={setPaso} setViewCovid={setViewCovid}/>: 
        ""
    )
}

export default CovidProto;